import { React, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { Form, Input, Button, DotLoading } from 'antd-mobile';
import { getLoginInfo, bindOpenId, getUnitInfo } from "api/api";
import { logo } from "utils/getImg";
import { userType } from "utils/constant";
import { UserContext } from 'utils/getContext'
import BpmToast from "components/BpmToast";
import { BpmButton } from "components/BpmButton";
import "static/css/login.css";

/** 登录注册页 */
export function Login() {
  const myContext = useContext(UserContext)
  const { userInfo, setUserInfo } = myContext
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const { state: { name, id_name, type, placeholder } } = useLocation()
  const [loading, setLoading] = useState(false);//是否显示加载效果
  const [testResult, setTestResult] = useState(false);//是否进行身份核验

  const { USER, UNIT } = userType

  //点击绑定/注册按钮
  async function handleSubmitClick() {
    if (testResult) {
      const formInfo = form.getFieldsValue()
      // 重组parm
      const parm = type === UNIT ? {
        name: formInfo.companyName,
        idNum: formInfo.creditCode,
        type: type
      } : {
        ...formInfo,
        type: type
      }
      bindOpenId(parm).then(res => {
        if (res.success) {
          BpmToast('登录成功,请稍后')
          localStorage.setItem("user", JSON.stringify(userInfo))
          setTimeout(() => {
            navigate('/', { state: { type: type } })
          }, 1000)
        } else {
          BpmToast('登录失败')
        }
      }).catch(err => {
        BpmToast('登录失败')
      })
    } else {
      BpmToast('请先进行身份核验')
    }
  }

  //校验成功后改变数据需重新校验
  function onValuesChange() {
    setTestResult(false)
  }

  //点击校验（type:5 个人 | 6 企业）
  async function handleLoginClick() {
    const parm = form.getFieldsValue()
    setLoading(true)
    const { data, msg } = type === USER ? await getLoginInfo(parm) : await getUnitInfo(parm)
    if (data) {
      if (data.check) {
        BpmToast(msg)
        setTestResult(true)
        setLoading(false)
        setUserInfo(data)
      } else {
        setLoading(false)
        BpmToast(msg)
        return
      }
    } else {
      BpmToast(msg || '请稍后重试')
      setLoading(false)
    }
  }

  return (
    <div className='loginPage'>
      <img src={logo} alt='logo'></img>
      <Form
        requiredMarkStyle='text-optional'
        layout='horizontal'
        name='login'
        form={form}
        onValuesChange={onValuesChange}
        footer={
          <BpmButton
            className='butColor'
            content='绑定/注册'
            onClick={handleSubmitClick}
          />
        }
      >
        <Form.Item
          name={name}
          rules={[{ required: true }]}
        >
          <Input
            placeholder={
              type === USER ? '请输入姓名' : '请输入企业名称'
            } />
        </Form.Item>
        <Form.Item
          name={id_name}
          rules={[{ required: true }]}
          extra={
            <Button
              className='testBut butColor'
              shape='default'
              color='primary'
              onClick={handleLoginClick}
            >
              {loading ? <DotLoading /> : '身份核验'}
            </Button>
          }
        >
          <Input
            placeholder={placeholder} />
        </Form.Item>
      </Form>
    </div>
  )
}